import { useContext } from 'react';

import { SmsServiceContext } from 'context/smsContext';
import type SmsService from 'services/sms/smsService';

export const useSmsService = () => useContext<SmsService>(SmsServiceContext);
